export const earlyApplyFlag = {
  tooltipContent: "This role only has a few applications. Apply now!",
  pillText: "fewer than ${submissionsNumber} submissions",
};
